import{e as _,g as t,m as e}from"./chunk-HBP5N4FR.js";var p={};t(p,{css:()=>o,default:()=>n});var o,n,s=_(()=>{e();o=`.dapp-core-component__styles__events {
  display: flex;
  flex-direction: column;
  margin-top: 0.25rem;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event {
  display: flex;
  border-left: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-left: 1rem;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event:not(:first-child) {
  padding-top: 1rem;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__icon {
  margin-left: -1.1rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  font-size: 0.9375rem;
  text-align: center;
  color: #6c757d;
  width: 2.1875rem;
  height: 2.1875rem;
  min-width: 2.1875rem;
  line-height: 2.1875rem;
  background: #fbfbfb;
  box-shadow: inset 0 0 3px rgba(108, 117, 125, 0.2);
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content {
  flex: 1;
  margin-top: 0.4rem;
  max-width: calc(100% - 1.5875rem);
  width: calc(100% - 1.5875rem);
  display: block;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
@media (min-width: 576px) {
  .dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row {
    flex-direction: row;
  }
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__label {
  color: #6c757d;
}
@media (min-width: 576px) {
  .dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__label {
    text-align: right;
  }
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__data {
  display: flex;
  align-items: center;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__hash {
  font-size: 1rem;
  align-items: flex-end;
  max-width: none;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__hash [class*=left] span,
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__hash [class*=right] span {
  font-size: 1rem;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__copy {
  margin-left: 0.5rem;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__copy svg path {
  fill: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__copy svg path:hover {
  fill: #1f43f4;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__explorer {
  color: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__explorer:hover {
  color: #1f43f4;
  text-decoration: none;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__address {
  position: relative;
  display: flex;
  max-width: 100%;
  overflow: hidden;
  width: auto;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__address span {
  max-width: none;
}
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__address span [class*=left] span,
.dapp-core-component__styles__events .dapp-core-component__styles__event .dapp-core-component__styles__content .dapp-core-component__styles__row .dapp-core-component__styles__address span [class*=right] span {
  font-size: 1rem;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));n={events:"dapp-core-component__styles__events",event:"dapp-core-component__styles__event",icon:"dapp-core-component__styles__icon",content:"dapp-core-component__styles__content",row:"dapp-core-component__styles__row",label:"dapp-core-component__styles__label",data:"dapp-core-component__styles__data",hash:"dapp-core-component__styles__hash",copy:"dapp-core-component__styles__copy",explorer:"dapp-core-component__styles__explorer",address:"dapp-core-component__styles__address"}});export{o as a,n as b,p as c,s as d};
//# sourceMappingURL=chunk-4SQM6OSS.js.map
